<template>
  <v-container fluid>
    <page-header>
      <template v-slot:title>
        <div>
          Estatisticas 📊
        </div>
      </template>
    </page-header>
    <v-row>
      <v-col cols="12" sm="6" md="6" lg="6">
        <default-card v-if="loadings['income_total_and_average']">
          <template slot="content">
            <card-loading-transparent />
          </template>
        </default-card>
        <default-total-and-average-card
          v-if="!loadings['income_total_and_average'] && all_data['income_total_and_average']"
          :totalValue="all_data['income_total_and_average'].total"
          :averageValue="all_data['income_total_and_average'].average"
          :title="'Receita'" :icon="'mdi-cash-plus'"
          :background_color="'rgba(00,200,00,0.2)'"
          :icon_color="'success'"
          class="mt-n1"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <default-card  v-if="loadings['outcome_total_and_average']">
          <template slot="content">
            <card-loading-transparent/>
          </template>
        </default-card>
        <default-total-and-average-card
          v-if="!loadings['outcome_total_and_average'] && all_data['outcome_total_and_average']"
          :totalValue="all_data['outcome_total_and_average'].total"
          :averageValue="all_data['outcome_total_and_average'].average"
          :title="'Despesa'" :icon="'mdi-cash-minus'"
          :background_color="'rgba(232,38,30,0.2)'"
          icon_color="red" 
          class="mt-n1"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <default-card v-if="loadings['ivoicing_total_and_average']">
          <template slot="content">
            <card-loading-transparent />
          </template>
        </default-card>
        <default-total-and-average-card
          v-if="!loadings['ivoicing_total_and_average'] && all_data['ivoicing_total_and_average']"
          :totalValue="all_data['ivoicing_total_and_average'].total"
          :averageValue="all_data['ivoicing_total_and_average'].average"
          :title="'Faturamento bruto'" 
          :icon="'mdi-cash'"
          icon_color='orange'
          :background_color="'rgba(245,156,52,0.4)'"
          class="mt-n1"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <default-card v-if="loadings['liquid_ivoicing_total_and_average']">
          <template slot="content">
            <card-loading-transparent />
          </template>
        </default-card>
        <default-total-and-average-card
          v-if="!loadings['liquid_ivoicing_total_and_average'] && all_data['liquid_ivoicing_total_and_average']"
          :totalValue="all_data['liquid_ivoicing_total_and_average'].total"
          :averageValue="all_data['liquid_ivoicing_total_and_average'].average"
          :title="'Faturamento líquido'"
          :icon="'mdi-cash-check'"
          :background_color="'rgba(63,167,255,0.3)'"
          icon_color='primary'
          class="mt-n1"
        />
      </v-col>
      <v-col v-if="false" cols="12" sm="6" md="4" lg="4">
        <default-total-and-average-card :averageValue="31000" :title="'Cachê médio'" :icon="'mdi-database-minus-outline'" :background_color="'#50C0FA'" class="mt-n1"/>
      </v-col>
      <v-col v-if="false" cols="12" sm="6" md="4" lg="4">
        <default-total-and-average-card :totalValue="200000" :averageValue="31000" :title="'Capital necessário / Equilíbrio'" :icon="'mdi-database-minus-outline'" :background_color="'#61BCE8'" class="mt-n1"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6" lg="6">
        <chart-by-category v-if="false" :start_date="start_date" :end_date="end_date" :movement_kind="'outcome'" :title="'Despesas por categoria'" :icon="'mdi-database-minus-outline'" :background_color="'#e33e43'"/>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <chart-by-category v-if="false" :start_date="start_date" :end_date="end_date" :movement_kind="'income'" :title="'Receita por categoria'" :icon="'mdi-database-plus-outline'" :background_color="'#4caf50'"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Api from '@/api'
  import { mapState, mapActions, mapGetters } from 'vuex'
  import PageHeader from '../shared/PageHeader.vue'

  export default {
    name: 'FinancialStatistics',
    data() {
      return {
        start_date: '',
        end_date: '',
        current_year: this.$dayjs().year(),
        all_data: {
          income_total_and_average: null,
          outcome_total_and_average: null,
          ivoicing_total_and_average: null,
          liquid_ivoicing_total_and_average: null
        },
        loadings: {
          income_total_and_average: null,
          outcome_total_and_average: null,
          ivoicing_total_and_average: null,
          liquid_ivoicing_total_and_average: null
        }
      }
    },
    components: {
      CalendarDatePicker: () => import ('../events_agenda/calendar/CalendarDatePicker.vue'),
      DefaultTotalAndAverageCard: () => import ('./counters/cards/financial/DefaultTotalAndAverageCard.vue'),
      ChartByCategory: () => import ('./counters/cards/financial/ChartByCategory.vue'),
      PageHeader
    },
    methods: {
      refreshData(){
        let filter = {
          start_date: this.start_date,
          end_date: this.end_date
        }
        this.getIncomeTotalAndAverage(filter)
        this.getOutcomeTotalAndAverage(filter)
        this.getIvoicingTotalAndAverage(filter)
        this.getLiquidIvoicingTotalAndAverage(filter)
      },
      getIncomeTotalAndAverage(filter){
        this.getDashCounter('income_total_and_average', filter)
      },
      getOutcomeTotalAndAverage(filter){
        this.getDashCounter('outcome_total_and_average', filter)
      },
      getIvoicingTotalAndAverage(filter){
        this.getDashCounter('ivoicing_total_and_average', filter)
      },
      getLiquidIvoicingTotalAndAverage(filter){
        this.getDashCounter('liquid_ivoicing_total_and_average', filter)
      },
      getDashCounter(kind, filter = {}){
        this.loadings[kind] = true
        if(this.activeCompanyId){
          Api.DashCounter.showByCompany(this.activeCompanyId, kind, filter).then(r=>r.data).then(d=>{
            this.all_data[kind] = d
          }).catch((err) => {
            console.log(err);
          }).finally(()=>{
            this.loadings[kind] = false
          })
        }
      },
      selectedYear(date){
        if(date){
          this.current_year = date
        }
        this.start_date = this.$dayjs().year(this.current_year).startOf('year').format('YYYY-MM-DD')
        this.end_date = this.$dayjs().year(this.current_year).endOf('year').format('YYYY-MM-DD')
        this.refreshData()
      },
      getData(){
        this.selectedYear()
      }
    },
    computed: {
      ...mapState({
        activeCompanyId: state => state.App.activeCompanyId
      }),
    },
    watch: {
      activeCompanyId(){
        this.refreshData()
      }
    },
    mounted() {
      this.getData()
    },
  }
</script>

<style lang="scss">
</style>